import React, {useState, useEffect} from "react";
import { io } from "socket.io-client";
import "./PWall.scss";
import { useTranslation } from "react-i18next";
import Xbutton from "components/Xbutton";
import { useHistory } from 'react-router-dom';

function PWall_Success({onExit, onContinue}) {
  
    const { t } = useTranslation();
    const history = useHistory();

    const goToHome = () => {
      if (typeof onContinue === 'function') {
        onContinue();
      } else {
        onExit();
        history.push('/');
      }
    }

    return (
      <>
        <div className="PWall_container">
            <div className="PWall_container__nav">
              <Xbutton 
                sizeM
                onClose={onExit}
              />
            </div>
            <div className="PWall_content">
              <div className="PWall_container__right">
                <div className="content">
                  <div className="PWall_success-container">
                    <div className="PWall_success-icon">
                      ✅
                    </div>
                    <div className="PWall_success-title">
                      {t('paywall.success.title')}
                    </div>
                    <button 
                      className="PWall_success-button"
                      onClick={goToHome}
                    >
                      {t('general.continue')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </>
    )
  }
  
  export default PWall_Success